import { ReactNode } from 'react'

export const SectionListContainer = ({ children }: { children: ReactNode }) => (
	<ul className="flex flex-col gap-4">{children}</ul>
)
